import { EntityType } from '../../../@types/entityTypes';
import workspaceQuery from '../../queries/sales/IntrastatDispatchInstructionLinesWorkspaceQuery.graphql';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';

const IntrastatDispatchInstructionLine: EntityType = {
  type: 'DispatchInstructionLine',
  title: 'Intrastat Dispatch Report',
  workspaceUrl: '/Sales/IntrastatDispatchInstructionLines/Workspace/',
  workspace: workspaceQuery,
  screenReference: 'INTRASTAT_DISPATCH_INSTRUCTION_LINES',
  operations: ALLOW_VIEW,
};

export default IntrastatDispatchInstructionLine;
